module.exports = __webpack_public_path__ + "img/carteira-entrada.243e0209.svg";